import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {JsonEditorOptions} from 'ang-jsoneditor';
import {LeftpanelComponent} from '../../leftpanel/leftpanel.component';

@Component({
  selector: 'app-results-viewer',
  templateUrl: './results-viewer.component.html',
  styleUrls: ['./results-viewer.component.scss']
})
export class ResultsViewerComponent implements OnInit {

  userView = 'json';
  responseCookies: any;
  responseCode: any;
  responseData: any;
  responseItems: any;
  responseText: any;
  @Input() responses: any;
  responseObject: any;
  responseError: any;
  responseTimestamp: any;
  responseHeaders: any;
  responseTime: any;
  apiByDefinition: any;
  @Output() flag = new EventEmitter<any>();
  options1 = new JsonEditorOptions();
  error = false;
  errorMessage: string;
  httpOperation = 'GET';
  httpOperations = [
    {'name': 'GET'},
    {'name': 'POST'},
    {'name': 'PUT'},
    {'name': 'PATCH'},
    {'name': 'DELETE'},
    {'name': 'COPY'},
    {'name': 'HEAD'},
    {'name': 'OPTIONS'},
    {'name': 'LINK'},
    {'name': 'UNLINK'},
    {'name': 'LOCK'},
    {'name': 'UNLOCK'},
    {'name': 'PROPFIND'},
    {'name': 'PURGE'},
    {'name': 'VIEW'}
  ];
  httpUrl: string;
  returnType = '';

  constructor(public platform: LeftpanelComponent) {
    this.options1.mode = 'code';
    this.options1.modes = ['code', 'text', 'tree', 'view'];
    this.options1.schema = '';
    this.options1.statusBar = false;
    this.options1.onChange = () => console.log(/* this.editor.get()*/);
  }

  ngOnInit() {
    this.returnType = '';
    this.responseItems = this.responses;
    if (this.responseItems.attributes) {
      for (const attribute of this.responseItems.attributes) {
        if (attribute['attributeName'].includes('$.result.')) {
          attribute['attributeName'] = attribute['attributeName'].replace('$.result.', '');
        }
      }
      this.apiByDefinition = this.responseItems.attributes;
    }
    if (this.responseItems.statusCode) {
      this.responseCode = this.responseItems.statusCode;
      if (this.responseCode >= 400) {
        this.error = true;
      } else {
        this.error = false;
      }
    }
    if (this.error) {
      if (this.responseItems && this.responseItems.body) {
        this.responseData = this.responseItems.body;
        this.errorMessage = this.responseItems.body;
        // this.errorMessage = this.responseData.message;
        this.responseError = this.responseData.error;
        // this.responseError = this.responseData.error;
      } else {
        // this.errorMessage = this.responseItems.message;
        this.errorMessage = this.responseItems.body;
        if (this.responseItems.error) {
          this.responseError = this.responseItems.error;
        }
      }
    }
    if (this.responseItems && this.responseItems.headers) {
      this.responseHeaders = this.responseItems.headers;
    }
    if (this.responseItems && this.responseItems.body) {
      if (this.responseHeaders) {
        const contentType = this.responseHeaders.filter(element => element.name.toLowerCase() === 'content-type');
        if (contentType && contentType.length > 0 && contentType[0]['name'].toLowerCase() === 'content-type') {
          if (contentType[0]['value'].includes('application/json')) {
            if (this.responseItems.body.startsWith('[{')) {
              this.returnType = 'Array';
              this.responseData = JSON.parse(this.responseItems.body);
            } else if (this.responseItems.body.startsWith('{')) {
              this.returnType = 'JSON Object';
              this.responseData = [];
              this.responseData.push(JSON.parse(this.responseItems.body));
            } else if (this.responseItems.body.startsWith('[')) {
              this.returnType = 'Array';
              this.responseData = JSON.parse(this.responseItems.body);
            }
          } else if (contentType[0]['value'].includes('application/xml') || contentType[0]['value'].includes('text/xml')) {
            if (contentType[0]['value'].includes('application/xml')) {
              const parser = new DOMParser();
              const xmlDoc = parser.parseFromString(this.responseItems.body, 'application/xml');
              this.responseText = this.prettifyXml(xmlDoc);
              this.returnType = 'XML';
              this.userView = 'xml';
            } else if (contentType[0]['value'].includes('text/xml')) {
              const parser = new DOMParser();
              const xmlDoc = parser.parseFromString(this.responseItems.body, 'text/xml');
              this.responseText = this.prettifyXml(xmlDoc);
              this.returnType = 'XML';
              this.userView = 'xml';
            } else {
              this.returnType = 'Text';
              this.responseText = (this.responseItems && this.responseItems.hasOwnProperty('body')) ? this.responseItems.body : '';
              this.userView = 'text';
            }
          } else {
            this.returnType = 'Text';
            this.responseText = (this.responseItems && this.responseItems.hasOwnProperty('body')) ? this.responseItems.body : '';
            this.userView = 'text';
          }
        } else {
          this.returnType = 'Text';
          this.responseText = (this.responseItems && this.responseItems.hasOwnProperty('body')) ? this.responseItems.body : '';
          this.userView = 'text';
        }
      } else {
        this.returnType = 'Text';
        this.responseText = (this.responseItems && this.responseItems.hasOwnProperty('body')) ? this.responseItems.body : '';
        this.userView = 'text';
      }

      // if (this.responseHeaders[0]['value'] !== 'text/plain') {
      //   if (this.responseItems.body.startsWith('[{')) {
      //     this.returnType = 'Array';
      //     this.responseData = JSON.parse(this.responseItems.body);
      //   } else if (this.responseItems.body.startsWith('{')){
      //     this.returnType = 'JSON Object';
      //     this.responseData = [];
      //     this.responseData.push(JSON.parse(this.responseItems.body));
      //   }
      // } else {
      //   this.responseText = this.responseItems.body;
      //   this.userView = 'text';
      // }






      // if (this.responseItems.body.startsWith('[{') || this.responseItems.body.startsWith('{') && this.responseHeaders[0]['value'] !== 'text/plain') {
      //   this.responseData = JSON.parse(this.responseItems.body);
      //
      // }
      // if (this.responseItems.body.startsWith('{') && this.responseHeaders[0]['value'] !== 'text/plain') {
      //   this.responseData = Array.of(this.responseData);
      // }
      // if (this.responseHeaders[0]['value'] === 'text/plain') {
      //   this.responseText = this.responseItems.body;
      //   this.userView = 'text';
      // }
    }
    this.responseTime = this.responses.timeInMillis;
  }

  prettifyXml (xmlDoc) {
    // const xmlDoc = new DOMParser().parseFromString(sourceXml, type);
    const xsltDoc = new DOMParser().parseFromString([
      // describes how we want to modify the XML - indent everything
      '<xsl:stylesheet xmlns:xsl="http://www.w3.org/1999/XSL/Transform">',
      '  <xsl:strip-space elements="*"/>',
      '  <xsl:template match="para[content-style][not(text())]">', // change to just text() to strip space in text nodes
      '    <xsl:value-of select="normalize-space(.)"/>',
      '  </xsl:template>',
      '  <xsl:template match="node()|@*">',
      '    <xsl:copy><xsl:apply-templates select="node()|@*"/></xsl:copy>',
      '  </xsl:template>',
      '  <xsl:output indent="yes"/>',
      '</xsl:stylesheet>',
    ].join('\n'), 'application/xml');

    const xsltProcessor = new XSLTProcessor();
    xsltProcessor.importStylesheet(xsltDoc);
    const resultDoc = xsltProcessor.transformToDocument(xmlDoc);
    const resultXml = new XMLSerializer().serializeToString(resultDoc);
    return resultXml;
  }

  getStatusCodeStyle(val) {
    if (val < 400) {
      return 'status-ok';
    } else {
      return 'status-not-ok';
    }
  }
  stringifyjson(val) {
    if (val != null) {
      return JSON.stringify(val, null, 2).trim();
    } else {
      return val;
    }
  }

  copyCode(code: string) {
    let dataToCopy: string;

    switch (this.userView) {
      case 'json':
        dataToCopy = this.stringifyjson(this.responseData);
        break;
      case 'html':
        dataToCopy = this.stringifyjson(this.responseData);
        break;
      case 'xml':
        dataToCopy = this.responseText; // Assuming responseText contains the XML data
        break;
      case 'text':
        dataToCopy = this.responseText; // Assuming responseText contains the text data
        break;
      default:
        // Handle default case or return error message
        break;
    }

    if (dataToCopy) {
      navigator.clipboard.writeText(dataToCopy)
          .then(() => {
            this.platform.openSnackBar('Copied to clipboard.', 'Success', {
              duration: 2000,
              verticalPosition: 'top',
              horizontalPosition: 'center'
            });
          })
          .catch((error) => {
            this.platform.openSnackBar('Failed to copy to clipboard.', 'Error', {
              duration: 2000,
              verticalPosition: 'top',
              horizontalPosition: 'center'
            });
          });
    } else {
      this.platform.openSnackBar('No data to copy.', 'Error', {
        duration: 2000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    }
  }
}
